import React from 'react';
import PropTypes from 'prop-types';

import { colorGray } from 'styles/layout/colors';

const IconPersonalInformation = ({
  className = '',
  color = colorGray,
  height = 48,
  width = 48,
}) => (
  <svg
    className={className}
    fill="none"
    height={height}
    viewBox="0 0 48 48"
    width={width}
  >
    <path
      d="M16.1334 23.3929C16.6906 22.6342 17.0443 21.7233 17.0443 20.7117C17.0443 18.2341 15.0211 16.2109 12.5435 16.2109C10.0659 16.2109 8.04266 18.2341 8.04266 20.7117C8.04266 21.7233 8.39633 22.6342 8.95351 23.3929C6.93031 24.1002 5.51367 26.074 5.51367 28.2493V29.8181C5.51367 30.4247 6.01947 30.8811 6.57666 30.8811H18.5636C19.1701 30.8811 19.6266 30.3753 19.6266 29.8181V28.2493C19.6246 26.0227 18.208 24.0508 16.1334 23.3929ZM12.5434 18.3349C13.8593 18.3349 14.8709 19.3979 14.8709 20.6624C14.8709 21.9269 13.8079 22.9899 12.5434 22.9899H12.492C11.2275 22.9899 10.1646 21.9269 10.1646 20.6624C10.2159 19.3979 11.2789 18.3349 12.5434 18.3349H12.5434ZM17.4493 28.7554H7.63777V28.2496C7.63777 26.9337 8.49723 25.7206 9.76172 25.3669C10.5204 25.1654 14.6182 25.1654 15.3771 25.3669C16.6416 25.7206 17.501 26.9357 17.501 28.2496V28.7554H17.4493Z"
      fill={color}
    />
    <path
      d="M40.9173 17.375H30.0942C29.4877 17.375 29.0312 17.8808 29.0312 18.438C29.0312 18.9952 29.537 19.501 30.0942 19.501H40.9173C41.5239 19.501 41.9803 18.9952 41.9803 18.438C41.9803 17.8808 41.5259 17.375 40.9173 17.375Z"
      fill={color}
    />
    <path
      d="M40.9173 22.4805H30.0942C29.4877 22.4805 29.0312 22.9863 29.0312 23.5435C29.0312 24.1006 29.537 24.6064 30.0942 24.6064H40.9173C41.5239 24.6064 41.9803 24.1006 41.9803 23.5435C41.9803 22.9863 41.5259 22.4805 40.9173 22.4805Z"
      fill={color}
    />
    <path
      d="M40.9173 27.5938H30.0942C29.4877 27.5938 29.0312 28.0996 29.0312 28.6567C29.0312 29.2139 29.537 29.7197 30.0942 29.7197H40.9173C41.5239 29.7197 41.9803 29.2139 41.9803 28.6567C41.9803 28.0996 41.5259 27.5938 40.9173 27.5938Z"
      fill={color}
    />
    <path
      d="M41.9813 11H6.06958C2.7305 11 0 13.7305 0 17.0696V30.019C0 33.3581 2.7305 36.0886 6.06958 36.0886H41.9297C45.2688 36.0886 47.9993 33.3581 47.9993 30.019V17.0696C48.0507 13.7325 45.3201 11 41.9813 11ZM2.12385 30.019V17.0696C2.12385 14.8942 3.89414 13.1239 6.06948 13.1239H22.9131V33.9624L6.06948 33.9643C3.89414 33.9643 2.12385 32.194 2.12385 30.0187V30.019ZM45.927 30.019C45.927 32.1944 44.1567 33.9647 41.9814 33.9647H25.0887V13.1243H41.9323C44.1077 13.1243 45.878 14.8945 45.878 17.0699L45.876 30.0193L45.927 30.019Z"
      fill={color}
    />
  </svg>
);

IconPersonalInformation.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
};

export default IconPersonalInformation;
